import '../styles.css';
import { Prestador } from '../../../../interfaces/entities/SaudeBemEstar/Agendamento/Prestador';
import { Horario } from '../../../../interfaces/entities/SaudeBemEstar/Agendamento/Horario';
import DefaultTable from '../../../../components/Accessibility/DefaultTable';
import TableBold from '../../../../components/Accessibility/DefaultTable/TableBold';
import TableRegular from '../../../../components/Accessibility/DefaultTable/TableRegular';
import DefaultTextBold from '../../../../components/Accessibility/DefaultTextBold';
import { getBenef } from '../../../../Store/storages/BeneficiarioStorage';
import { useEffect, useState } from 'react';
import DefaultButton from '../../../../components/Accessibility/DefaultButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { postAgendar } from '../../../../services/SaudeBemEstar/SaudeEmocionalService';
import { Agendamento } from '../../../../interfaces/entities/Agendamento';
import { cancelarAgendamento } from '../../../../services/AgendamentoService';
import { getDayNameExtenso } from '../../../../utils/DateFormat';
import moment from 'moment';
import ContatoModal from './ContatoModal/ContatoModal';
import ConfirmacaoModal from './ConfirmacaoModal/ConfirmacaoModal';
import { CircularProgress } from '@mui/material';
import LoadingApp from '../../../../components/LoadingApp';

const Step3ConfirmarDados: React.FC<{
  prestador: Prestador | undefined,
  horario: Horario | undefined,
  prevAgendamento?: Agendamento | null
}> = ({ prestador, horario, prevAgendamento }) => {

  const { contrastStyle } = useAccessibility();

  const [userData, setUserData] = useState<{ tel: string; cel: string; email: string } | null>(null)
  const [showContatoModal, setShowContatoModal] = useState<boolean>(false);
  const [showConfirmacaoModal, setShowConfirmacaoModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleAtualizarContato = ({ tel, cel, email }: { tel: string, cel: string, email: string }) => {
    setUserData({
      tel, cel, email
    })
    setShowContatoModal(false);
  }

  const handleCancelarAtualizarContato = () => {
    setShowContatoModal(false);
  }

  useEffect(() => {
    setUserData(getBenef())
  }, []);

  const handleAgendar = async () => {
    if (!prestador || !horario) return;

    setLoading(true);

    if (prevAgendamento) {
      await cancelarAgendamento(prevAgendamento.idInstal, prevAgendamento.id)
    }

    await postAgendar(
      prestador.idInstal,
      prestador.idPessoa,
      prestador.especialidade,
      `${horario?.data} ${horario?.hora}`,
      userData?.cel || '(31) 99999999',
      userData?.tel || '(31) 99999999',
      userData?.email || '(31) 99999999'
    )

    setLoading(false);
    setShowConfirmacaoModal(true);
  }

  const dataAgendamento = [
    [<TableBold text="Profissional" />, <TableRegular text={prestador?.nome || ''} />],
    [<TableBold text="Especialidade" />, <TableRegular text={prestador?.especialidade || ''} />],
    [<TableBold text="Horário" />, <TableRegular text={`${horario?.data} - ${getDayNameExtenso(moment(horario?.data, 'DD/MM/YYYY').day())} às ${horario?.hora}`} />]
  ]

  const dataContato = [
    [<TableBold text="Telefone" />, <TableRegular text={userData?.tel || '-'} />],
    [<TableBold text="Celular" />, <TableRegular text={userData?.cel || '-'} />],
    [<TableBold text="Email" />, <TableRegular text={userData?.email || '-'} />]
  ]

  if (prestador && horario) {
    return (
      <>
        <DefaultTextBold text="Confirmação da reserva do agendamento" />
        <DefaultTable
          data={dataAgendamento}
          columnWidths={['25%', '75%']}
        />

        <DefaultTextBold text="Confirme seus dados de contato" />
        <DefaultTable
          data={dataContato}
          headers={["Dados de contato"]}
          columnWidths={['25%', '75%']}
        />

        <div className="flex-row align-center">
          
          <button
            className="editar-contato-button"
            onClick={() => setShowContatoModal(true)}
            style={contrastStyle}>
            <FontAwesomeIcon icon={faEdit} color="#00834F" style={{...contrastStyle, marginRight: '5px'}} />
            Alterar dados de contato
          </button>
        </div>

        <DefaultButton text="Confirmar" onClick={handleAgendar} />

        {showContatoModal && <ContatoModal
          userData={userData || { cel: '', tel: '', email: '' }}
          showModal={showContatoModal}
          handleCancelarClick={handleCancelarAtualizarContato}
          handleSalvarClick={handleAtualizarContato}
        />}


        {showConfirmacaoModal && <ConfirmacaoModal showModal={showConfirmacaoModal} />}

        {loading && <LoadingApp showLoading={loading} />}
      </>

    )
  }

}

export default Step3ConfirmarDados;